/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rosy_Pearl_Mule_SinkInputs */

const en_rosy_pearl_mule_sink = /** @type {(inputs: Rosy_Pearl_Mule_SinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manage this user's attributes. Attributes are used in surveys and other features.`)
};

const de_rosy_pearl_mule_sink = /** @type {(inputs: Rosy_Pearl_Mule_SinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Merkmale dieses Benutzers verwalten. Merkmale werden in Befragungen und anderen Funktionen verwendet.`)
};

/**
* | output |
* | --- |
* | "Manage this user's attributes. Attributes are used in surveys and other features." |
*
* @param {Rosy_Pearl_Mule_SinkInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const rosy_pearl_mule_sink = /** @type {((inputs?: Rosy_Pearl_Mule_SinkInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rosy_Pearl_Mule_SinkInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_rosy_pearl_mule_sink(inputs)
	return de_rosy_pearl_mule_sink(inputs)
});